// extracted by mini-css-extract-plugin
export default {"homeRooms":"HomeRooms_homeRooms__7uUMP","imgBlock_left":"HomeRooms_imgBlock_left__qsfAv","homeRoomsContainer":"HomeRooms_homeRoomsContainer__Ggebw"};